export const L10N = {
  ACTION_SEND: { id: 'common.action.send' },
  LABEL_SEND_MESSAGE: { id: 'lisa.label.send_message' },
};
